module.exports = __webpack_public_path__ + "static/media/ilustraTopper.97ddbcf3.png";